
<template lang="pug">
  fieldset.option-select.option-select--buttons
    legend.option-select__legend(v-if="label")
      span.option-select__legend--title {{ label }}
    .option-select__label-wrapper
      label.option-select__label(
        v-for="option in optionSet"
        tabindex="0"
        :class="{ 'is-selected': option.value === value }"
        :disabled="option.disabled"
        @keyup.space="onChange(option.value)"
        @keydown.space.prevent
      )
        .option-select__label__title {{ option.label }}
        .option-select__label__price
          span.option-select__label__price__text {{ option.price | money }}
          span.option-select__label__price__savings(v-if="option.discount") Save {{ option.discount }}%
        input.u-sr-only(
          type="radio"
          tabindex="-1"
          :id="option.label"
          :value="currentValue"
          :disabled="option.disabled"
          name="variant"
          @change.prevent="onChange(option.value)"
        )
</template>

<script>
  import { getDiscountPercent } from 'scripts/helpers/tags.js';

  import OptionSelectButtons from 'scripts/components/forms/OptionSelectButtons.vue';

  export default {
    name: 'VariantSelectButtons',
    extends: OptionSelectButtons,
    props: {
      subscriptionSelected: Boolean,
      variantsWithSubscriptions: {
        type: Set,
        default: () => new Set(),
      }
    },
    computed: {
      optionSet () {
        return [...this.product.variants].map((variant, index) => {
          return {
            label: variant[this.option],
            value: variant[this.option],
            price: variant.price,
            discount: getDiscountPercent(this.product.tags, variant.id),
            disabled: this.subscriptionSelected && !this.variantsWithSubscriptions.has(variant.id),
          };
        });
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
